import { useState, useEffect } from "react";
import { api } from "../api/client";

const STATUS_LABEL = { berechnet: "Berechnet", geprueft: "Geprüft", freigegeben: "Freigegeben", exportiert: "Exportiert" };
const NAECHSTER_STATUS = { berechnet: "geprueft", geprueft: "freigegeben", freigegeben: "exportiert" };

/**
 * Sitzungsgeld-Widget, eingebettet in die Sitzungs-Detailseite (Prinzip
 * "keine neuen Routen ohne Not"). Optionales Modul (Phase 14) - erscheint
 * nur, wenn es tatsächlich genutzt wird (Regeln konfiguriert oder bereits
 * berechnet), drängt sich sonst nicht auf.
 */
export default function SitzungsgeldWidget({ sitzungId, gremiumId }) {
  const [liste, setListe] = useState(null);
  const [regeln, setRegeln] = useState(null);
  const [zeigeRegelForm, setZeigeRegelForm] = useState(false);
  const [regelBezeichnung, setRegelBezeichnung] = useState("");
  const [regelBetrag, setRegelBetrag] = useState("");

  const laden = () => {
    api.getSitzungsgeld(sitzungId).then(setListe).catch(() => setListe([]));
    api.getSitzungsgeldregeln().then(setRegeln).catch(() => setRegeln([]));
  };
  useEffect(() => { laden(); }, [sitzungId]);

  if (liste === null || regeln === null) return null;

  const regelAnlegen = async () => {
    const betragCent = Math.round(parseFloat((regelBetrag || "0").replace(",", ".")) * 100);
    if (!regelBezeichnung.trim() || !betragCent) return;
    await api.createSitzungsgeldregel({ bezeichnung: regelBezeichnung.trim(), grundbetrag_cent: betragCent, gremium_id: gremiumId || null });
    setRegelBezeichnung(""); setRegelBetrag(""); setZeigeRegelForm(false);
    laden();
  };

  // Weder Regel noch Berechnung vorhanden -> Modul ungenutzt. Bietet aber
  // dezent an, es hier erstmalig einzurichten, statt sich komplett zu
  // verstecken (sonst gäbe es nirgends einen Einstieg dafür).
  if (regeln.length === 0 && liste.length === 0 && !zeigeRegelForm) {
    return (
      <div className="card" style={{ marginTop: 16 }}>
        <div className="card-body" style={{ fontSize: 12.5, color: "var(--ink-faint)" }}>
          Sitzungsgeld ist für dieses Gremium noch nicht eingerichtet.{" "}
          <button className="btn btn-ghost btn-sm" onClick={() => setZeigeRegelForm(true)}>Jetzt einrichten</button>
        </div>
      </div>
    );
  }

  const berechnen = async () => {
    try {
      await api.sitzungsgeldBerechnen(sitzungId);
      laden();
    } catch (e) {
      alert("Berechnung fehlgeschlagen: " + (e?.message || e));
    }
  };

  const weiter = async (id, aktuellerStatus) => {
    const naechster = NAECHSTER_STATUS[aktuellerStatus];
    if (!naechster) return;
    await api.sitzungsgeldStatus(id, naechster);
    laden();
  };

  return (
    <div className="card" style={{ marginTop: 16 }}>
      <div className="card-header">
        <h3>Sitzungsgeld</h3>
        {liste.length === 0 && regeln.length > 0 && <button className="btn btn-secondary btn-sm" style={{ marginLeft: "auto" }} onClick={berechnen}>Berechnen</button>}
      </div>

      {regeln.length === 0 && (
        <div className="card-body">
          <div style={{ fontSize: 12.5, color: "var(--ink-soft)", marginBottom: 10 }}>
            Noch keine Sitzungsgeldregel konfiguriert. Ohne Regel kann nichts berechnet werden.
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <input className="form-control" placeholder="Bezeichnung, z.B. Standard" style={{ maxWidth: 200 }}
                   value={regelBezeichnung} onChange={e => setRegelBezeichnung(e.target.value)} />
            <input className="form-control" placeholder="Betrag in €" style={{ maxWidth: 120 }}
                   value={regelBetrag} onChange={e => setRegelBetrag(e.target.value)} />
            <button className="btn btn-primary btn-sm" onClick={regelAnlegen}>Regel anlegen</button>
          </div>
        </div>
      )}

      {liste.length > 0 ? (
        <table className="table">
          <thead><tr><th>Mitglied-ID</th><th>Betrag</th><th>Status</th><th></th></tr></thead>
          <tbody>
            {liste.map(b => (
              <tr key={b.id}>
                <td>{b.mitglied_id}</td>
                <td>{(b.betrag_cent / 100).toLocaleString("de-DE", { style: "currency", currency: "EUR" })}</td>
                <td><span className="badge badge-in_bearbeitung">{STATUS_LABEL[b.status] || b.status}</span></td>
                <td className="actions">
                  {NAECHSTER_STATUS[b.status] && (
                    <button className="btn btn-ghost btn-sm" onClick={() => weiter(b.id, b.status)}>
                      → {STATUS_LABEL[NAECHSTER_STATUS[b.status]]}
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : regeln.length > 0 ? (
        <div className="card-body" style={{ color: "var(--ink-faint)", fontSize: 12.5 }}>
          Noch nicht berechnet. Berechnung erfasst alle als anwesend markierten Mitglieder anhand der konfigurierten Sitzungsgeldregel.
        </div>
      ) : null}
    </div>
  );
}
